var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Page not found.")]),_c('b-button',{attrs:{"type":"is-primary is-rounded"},on:{"click":function($event){return _vm.$router.push({ name: 'Home' })}}},[_vm._v(" Back ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }